<template>
  <div class="dati_warp">
    <div class="dati_bg">
       <div class="wrapper"  v-if="seq == `${seq}`">
        <div class="title">
          <div class="book_icon">
            <img src="/imgs/careerEvaluation/success.png" alt="" />
          </div>
          <h4>{{tip2}}</h4>
        </div>

        <div class="btn_warp">
           <!-- <a v-if="type!='test'" href="javascript:;" class="btn btn_goon" @click="go">点击继续</a> -->
           <button v-if="type!='test'">
            <a @click="go">{{goOn}}</a
            >
          </button>

        </div>
      </div>
      <div class="wrapper" v-else>
        <div class="title">
          <div class="book_icon">
            <img src="/imgs/careerEvaluation/success.png" alt="" />
          </div>
          <h4>{{datas[type]['tip']}}</h4>
<!--          <h4>本次测评已完成,点击进入下一个测评//本次测评练习已完成//第N次测试文成</h4>-->
        </div>
        <div class="btn_warp">
          <button v-if="type=='test'" @click="$router.push(url)">继续练习</button>
          <button @click="$router.push(url)">
<!--              进入下一题/点击继续/完成练习-->
            {{datas[type]['text']}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "success",
  data(){
    return {
      type: this.$route.query.type,
      seq: this.$route.query.seq,
      url: this.$route.query.url,
      url2:this.$route.query.url2,
      part:this.$route.query.part,
      number:'',
      tip:'',
      tip2: '',
      goOn:'点击继续',
      kongTest: sessionStorage.getItem('kongTest'),
      datas:{
        test:{
          tip:'本次练习结束',
          text:'完成练习'
        },
        answer:{
          tip:this.number?'点击继续':this.$route.query.part?'本部分测试已完成，进入下一部分':'本测验已完成，点击进入下一个',
          text:this.number?`第${this.number}次测验已完成`:this.$route.query.part?'进入下一部分':'进入下一个'
        }
      }
    }
  },
  mounted(){
      if (this.type == 'test') {
          this.tip2 = '练习完成！';
      } else if (this.seq == 6) {
        this.tip2 = '本测验已完成，点击进入下一个'
        this.goOn = "进入下一个"
      } else {
        this.tip2 = '第' + this.seq + '次测试完成!';
      }
  },
  methods:{
    go: function () {
        if (this.seq == 6) {
          this.$router.push({
            path:'/careerevalution/home',
            query: { name:'znsp',part:'znsp91'}
          })
        } else {
          this.seq = Number(this.seq) + 1;
          this.$router.push('/careerevalution/znsp/ques81?seq=' + this.seq);
        }
      },
  }
}
</script>

<style scoped>
  .title {
    /* height: 300px; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 100px;
  }

  .title h4 {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    margin-top: 25px;
  }

</style>